import { render, staticRenderFns } from "./Classify.vue?vue&type=template&id=1b64ce43&scoped=true"
import script from "./Classify.vue?vue&type=script&lang=js"
export * from "./Classify.vue?vue&type=script&lang=js"
import style0 from "./Classify.vue?vue&type=style&index=0&id=1b64ce43&prod&lang=css"
import style1 from "./Classify.vue?vue&type=style&index=1&id=1b64ce43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b64ce43",
  null
  
)

export default component.exports